import * as React from 'react'
import { Accordion, Button, Card, Form, Image, Table } from 'react-bootstrap'
import IosClose from 'react-ionicons/lib/IosClose'
import IosCreateOutline from 'react-ionicons/lib/IosCreateOutline'
import IosOpenOutline from 'react-ionicons/lib/IosOpenOutline'

import { MaintenanceRecord, Make, Model, Odometer, Vehicle } from './types'


let od1 : Odometer = {
    id: 53,
    mileage: 74732,
    readingDate: new Date()
}

let od2 : Odometer = {
    id: 35,
    mileage: 52600,
    readingDate: new Date()
}

const VEHICLES_LIST : Array<Vehicle> = [
    {
        id: 3,
        vin: 'dafear352sdfaSD',
        make: Make.Ford,
        model: Model.F350,
        fkVendor: 4,
        inspections: [],
        odometer: [od1],
        nickname: 'Truck #1', 
        fuelEfficiency: 15,
        pics: ['https://photos.motorcar.com/used-2014-gmc-savana_commercial_4500_cutaway_16_apostrophe_ft_box_truck-4500van177-12881-19680952-1-640.jpg'],
        maintenanceRecords: []
    },
    {
        id: 5,
        vin: 'kl4alfkjsdf',
        make: Make.Chevy,
        model: Model.F350,
        fkVendor: 6,
        inspections: [],
        nickname: 'Truck #2',
        odometer: [od2],
        fuelEfficiency: 13,
        pics: ['https://www.pensketruckrental.com/imgs/trucks-large/img_rental_26cargovan.jpg'],
        maintenanceRecords: []
    }
]

// NOTE: We will assume that inspections are ordered upon insertion, not upon query.
// We will paginate this section by ENTRIES_PER_PAGE = 20 and this will allow for fastest db query this way
const INSPECTIONS = [
    {
        inspectionDate: 'Sep 10, 2020',
        inspector: 'Colorado Auditors'        
    },
    {
        inspectionDate: 'Sep 10, 2019',
        inspector: 'Denver Aud'
    },
    {
        inspectionDate: 'Sep 9, 2018',
        inspector: 'Dan Brown LLC'
    }
]

const DAMAGES = [
    {
        area: 'Bumper',
        images: 'https://www.autotrainingcentre.com/wp-content/uploads/2016/12/Here-are-the-three-steps-that-auto-body-technicians-will-follow-when-repairing-them.jpg|https://www.autobody-review.com/images/groups/0/article/B54Y069Imq0rTpMAno36.jpg', // |-separated list
        observedDate: 'Aug 30, 2018',
        notes: 'Some notes about how the bumper got damaged and how extreme the damage actually was.',
        severity: 'Mild'    // Mild | Decent | Great | Extreme
    },
    {
        area: 'Left Door',
        images: 'https://www.autotrainingcentre.com/wp-content/uploads/2016/12/Here-are-the-three-steps-that-auto-body-technicians-will-follow-when-repairing-them.jpg|https://www.autobody-review.com/images/groups/0/article/B54Y069Imq0rTpMAno36.jpg', // |-separated list
        observedDate: 'Jan 3, 2017',
        notes: 'Some notes about how the bumper got damaged and how extreme the damage actually was.',
        severity: 'Decent'    // Mild | Decent | Great | Extreme
    }
]

interface VehiclesProps {
    company : any
}

const vehicleStyle = {
    display: 'grid',
    gridTemplateColumns: '200px 1fr'
}

const Vehicles : React.FunctionComponent<VehiclesProps> = ({ company }) : JSX.Element => {
    let [showDamagesIndex, setShowDamagesIndex] = React.useState(null)
    let [showInspectionsIndex, setShowInspectionsIndex] = React.useState(null)

    let renderVehicles = () => {
        let v = []
        VEHICLES_LIST.map(vehicle => {
            v.push(
                <>
                    <Card.Header>
                        <Accordion.Header as={Button} variant="link" eventKey={vehicle.id.toString()}>
                            <div style={vehicleStyle}>
                                <Image src={vehicle.pics[0]} height={75} />
                                <h5>{vehicle.nickname}</h5>
                            </div>
                        </Accordion.Header>
                    </Card.Header>
                    <Accordion.Collapse eventKey={vehicle.id.toString()}>
                        <Form>
                            <Form.Group>
                            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                                    <span>
                                        <Image src={vehicle.pics[0]} height={60} />
                                        <br />
                                        <Button variant='outline-info'>Upload</Button>
                                    </span>
                                    <span>
                                        <Form.Label>Vehicle Nickname</Form.Label>
                                        <Form.Control className='input-material' />
                                    </span>
                                </div>
                                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                                    <span>
                                        <Form.Label>Make</Form.Label>
                                        <Form.Control className='input-material' />
                                    </span>
                                    <span>
                                        <Form.Label>Model</Form.Label>
                                        <Form.Control className='input-material' />
                                    </span>
                                </div>
                                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                                    <span>
                                        <Form.Label>Odometer Reading, miles</Form.Label>
                                        <Form.Control className='input-material' />
                                    </span>
                                    <span>
                                        <Form.Label>Gas Rating, gpm</Form.Label>
                                        <Form.Control className='input-material' />
                                    </span>
                                </div>
                                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                                    <span>
                                        <Form.Label>Gross Vehicle Weight Rating (GVWR)</Form.Label>
                                        <Form.Control className='input-material' />
                                    </span>
                                    <span>
                                        <Form.Label>Vehicle Identification Number (VIN)</Form.Label>
                                        <Form.Control className='input-material' />
                                    </span>
                                </div>
                            </Form.Group>
                            <Form.Group>
                                <h4>Inspections</h4>
                                {INSPECTIONS.length > 0 && <Table>
                                    {INSPECTIONS.reverse().map((item : any, index : number) => {
                                        return (
                                            <>
                                                <tr>
                                                    <td>{item.inspectionDate}</td>
                                                    <td>{item.inspector}</td>
                                                    <td style={{textAlign: 'right'}}>
                                                        <IosCreateOutline color="blue" fontSize="40px"
                                                            onClick={() => {showInspectionsIndex == null ? setShowInspectionsIndex(index) : setShowInspectionsIndex(null)}} />
                                                        <IosClose color="red" fontSize="40px" />
                                                    </td>
                                                </tr>
                                                {showInspectionsIndex == index && <tr>
                                                    <td colSpan={3}>
                                                        <Form.Control as="textarea" rows={3} />
                                                    </td>
                                                </tr>}
                                            </>
                                        )
                                    })}
                                </Table>}
                            </Form.Group>
                            <Form.Group>
                                <h4>Damages</h4>
                                {DAMAGES.length > 0 && <Table>
                                    {DAMAGES.map((item : any, index : number) => {
                                    return (
                                        <>
                                            <tr>
                                                <td>
                                                    {item.observedDate}
                                                </td>
                                                <td>
                                                    {item.severity}
                                                </td>
                                                <td>
                                                    {item.images.split('|').map(image => {
                                                        return <Image src={image} height={40} />
                                                    })}
                                                </td>
                                                <td style={{textAlign: 'right'}}>
                                                    <IosCreateOutline color="blue" fontSize="40px"
                                                        onClick={() => {showDamagesIndex == null ? setShowDamagesIndex(index) : setShowDamagesIndex(null)}} />
                                                    <IosClose color="red" fontSize="40px" />
                                                </td>
                                            </tr>
                                            {showDamagesIndex == index && <tr>
                                                <td colSpan={4}>
                                                    <Form.Control as="textarea" rows={3} />
                                                </td>
                                            </tr>}
                                        </>
                                    )
                                })}
                                </Table>}
                                <Button variant='outline-info'>Add Damage</Button>
                            </Form.Group>
                            <Form.Group>
                                <h4>History</h4>
                                {DAMAGES.length > 0 && <Table>
                                    {DAMAGES.map((item : any) => {
                                    return (
                                        <tr>
                                            <td>
                                                {item.observedDate}
                                            </td>
                                            <td>
                                                {item.severity}
                                            </td>
                                            <td>
                                                {item.images.split('|').map(image => {
                                                    return <Image src={image} height={40} />
                                                })}
                                            </td>
                                            <td style={{textAlign: 'right'}}>
                                                <IosOpenOutline color="blue" fontSize="40px" />
                                                <IosClose color="red" fontSize="40px" />
                                            </td>
                                        </tr>
                                    )
                                })}
                                </Table>}
                            </Form.Group>
                            <Button variant='info'>Save Vehicle</Button>
                            <Button variant='danger'>Delete Vehicle</Button>
                        </Form>
                    </Accordion.Collapse>
                </>)
        })
        return <Accordion>{v}</Accordion>
    }

    return (
        <div>
            {renderVehicles()}
        </div>
    )
}

export default Vehicles